export const environment = process.env.REACT_APP_ENV || 'DEV';
//export const  baseApiUrl = 'https://puspendu.csdservice.dinetestapi.com/api';

//export const  baseApiUrl = 'https://surityselect.api.redoq.host/api';

//export const  baseApiUrl = 'http://65.1.176.214:1295/api';

const sanitizeHost = (host) => {
  if (!host) return '';

  return host
    .replace(/^https?:\/\//, '')
    .replace(/^www\./, '')
    .replace(/\/$/, '')
    .trim()
    .toLowerCase();
};

const getApiBaseUrl = () => {
  const hostname = window.location.hostname;
  const newhostname = sanitizeHost(hostname);

  if (newhostname === 'd1s7bb33fw1ahc.cloudfront.net') {
    return 'https://staging.surityselect.api.redoq.host/api';
  } else if (newhostname === 'surityselect.com') {
    return 'https://surityselect.api.redoq.host/api';
  } else if (newhostname === 'localhost') {
    return 'https://staging.surityselect.api.redoq.host/api';
  } else {
    return 'https://surityselect.api.redoq.host/api';
  }
};

export const baseApiUrl = process.env.REACT_APP_API_BASE_URL || getApiBaseUrl();

// export const  baseApiUrl = 'https://staging.surityselect.api.redoq.host/api';

export const LOGIN_PAGE = '/authentication/login';
//export const emailRegEx = /^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/;
export const telephoneRegEx = /^[0-9]{10,11}$/;
export const passwordRegEx = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
export const pagesizeArray = [3, 5, 8, 10];

export const emailRegEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const imageBaseUrl =
  process.env.REACT_APP_IMAGE_LINK || 'https://surityselect.com/assets/img/';
export const pdfBaseUrl = process.env.REACT_APP_PDF_LINK || 'https://surityselect.com/assets/pdfs/';
